import { Facebook, Instagram, Linkedin, Music2, Youtube, type LucideIcon } from 'lucide-react';

export const platformIcon = (platform: string): LucideIcon => {
  if (platform === 'instagram') return Instagram;
  if (platform === 'youtube') return Youtube;
  if (platform === 'facebook') return Facebook;
  if (platform === 'linkedin') return Linkedin;
  return Music2;
};

export const platformAccentClass = (platform: string): string => {
  if (platform === 'youtube') return 'bg-red-500';
  if (platform === 'instagram') return 'bg-pink-500';
  if (platform === 'facebook') return 'bg-[#1877F2]';
  if (platform === 'linkedin') return 'bg-sky-700';
  return 'bg-cyan-500';
};
